import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { Stack, SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React, { PropsWithChildren } from 'react';

import { ViewWrapperPaperStyles } from '@/components/viewWrapper/viewWrapper.styles.ts';
import { themeColors } from '@/config/theme/themeColors.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

type Props = PropsWithChildren & {
  id?: string;
  isError?: boolean;
  isLoading?: boolean;
  sx?: SxProps<Theme>;
};

export const ViewWrapper: React.FC<Props> = props => {
  const { t: tError } = useTranslationWithPrefix('utils.errorMessages');
  const { children, id, isError, isLoading, sx } = props;

  const mainStyles = { ...ViewWrapperPaperStyles, ...(sx ?? {}) };

  if (isLoading) {
    return (
      <Paper square sx={{ ...mainStyles, pt: 6 }}>
        <Box
          sx={{ alignItems: 'center', display: 'flex', height: '100%', justifyContent: 'center' }}
        >
          <CircularProgress size={64} sx={{ color: themeColors.accentColor }} />
        </Box>
      </Paper>
    );
  }

  if (isError) {
    return (
      <Paper square sx={mainStyles}>
        <Box
          sx={{ alignItems: 'center', display: 'flex', height: '100%', justifyContent: 'center' }}
        >
          <Stack
            direction="row"
            spacing={3}
            sx={{ alignItems: 'center', justifyContent: 'space-between' }}
          >
            <ReportProblemOutlinedIcon sx={{ color: themeColors.red, fontSize: '48px' }} />
            <Typography variant="f16Medium">{tError('unknownError')}</Typography>
            <ReportProblemOutlinedIcon sx={{ color: themeColors.red, fontSize: '48px' }} />
          </Stack>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper id={id} square sx={mainStyles}>
      <Box sx={{ height: '100%', width: '100%' }}>{children}</Box>
    </Paper>
  );
};
